import React, { useState, useEffect } from 'react';
import ExportButton from '../../components/Shared/ExportButton/ExportButton';
import SearchBar from '../../components/Shared/SearchBar/SearchBar';
import Pagination3 from '../../components/Shared/Pagination/Pagination3';
import Table from '../../components/Shared/Table/CategTable';
import styles from '../ContactUs/ContactUs.module.css';
import { SelectChangeEvent } from '@mui/material';
import { showErrorToast, showSuccessToast } from '../../components/Shared/Toastify/toastHelper';
import ArchiveModal from '../../components/Shared/ArchiveModal/ArchiveModal';
import Modal, { Styles } from 'react-modal';
import { Property } from 'csstype';
import { Link, useNavigate } from 'react-router-dom';
import AddButton from '../../components/Shared/AddButton/AddButton';
import { FAQdto, FAQService } from '../../services/FAQSerivce';

Modal.setAppElement('#root');



const ContactUs: React.FC = () => {
  const navigate = useNavigate();
  const columns = [
    { title: 'ID' },
    { title: 'Question' },
    { title: 'Answer' },
    { title: 'Created Date' },
  ];

  const [message, setMessage] = useState<FAQdto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState<boolean>(true);  
  const [searchTerm,setSearchTerm] = useState<string>("");
  const [total,setTotal]=useState(0)
  const [selectedMessageId,setSelectedMessageId]=useState<string|null>(null);
  const [mode,setMode]=useState<'delete'>('delete')
  const [showModal,setShowModal]=useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [viewIndex,setViewIndex]=useState<number>(0);
const [sortColumn, setSortColumn] = useState<string | null>(null);
const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
const columnKeyMapping: { [key: string]: string } = {
  'ID': '_id',
  'Question': 'question',
  'Answer': 'answer',
  'Created Date': 'createdAt',
};

  const handleSort = (column: string) => {
    const backendKey = columnKeyMapping[column];
    if (!backendKey) return;
    if(loading) return;
    setLoading(true)
    if (sortColumn === backendKey) {
        setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
        setSortColumn(backendKey);
        setSortDirection('asc');
    }
};  

  const handleSearchChange = (value: string) => {
      setLoading(true)
      setCurrentPage(1)

      setSearchTerm(value); 
  };
  
  const [pageSize, setPageSize] = useState(10);
  const handlePageSizeChange = (event: SelectChangeEvent<unknown>) => {
    setLoading(true)
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };





  useEffect(() => {
    const fetMessages = async () => {
      try {
          const response = await FAQService.getFAQs(currentPage,pageSize,searchTerm,sortColumn || '',sortDirection);
          
          if (response && response.faqs && Array.isArray(response.faqs)) {
            setMessage(response.faqs);
            setTotal(response.total)
          } else {
            console.error('Expected an array in response.data but got:', response);

          }
      } catch (error:any) {
        showErrorToast('Error fetching messages: '+error.message)
        
        setMessage([]);
      }finally{
        setLoading(false)
      }
    };

    fetMessages();
  }, [currentPage,pageSize,searchTerm,sortColumn,sortDirection]);




  const handlePageChange = (page: number) => {
    setLoading(true)
    setCurrentPage(page);
  };

  

  const handleDeleteClick = (id:string): void => {
    setSelectedMessageId(id);
    setMode('delete');
    setShowModal(true);
};
  
const handleConfirmAction = async (): Promise<void> => {
  if (selectedMessageId) {
      setLoading(true)
          try {
            if (mode === 'delete') {
              await FAQService.deleteFAQ(selectedMessageId);
              showSuccessToast("Message deleted successfully.");
            }
            setMessage(message.filter(publisher => publisher._id !== selectedMessageId));
          } catch (error:any) {
            
            showErrorToast(`Error deleting message: `+error.message);
            
          }finally {
              setSelectedMessageId(null);
              setLoading(false)
          }
    }
  setShowModal(false);
};  
const handleCancelAction = (): void => {
  setSelectedMessageId(null);
  setShowModal(false);
};


  const formatDate = (oldDate:string): string => {
    if(!oldDate){
        return " "
    }
    const date = new Date(oldDate);
    const formattedDate = date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    });
    return formattedDate;
}

const toggleModal=()=>{
  setIsOpen((prev)=>!prev);
}

const handleEditClick = (index: number) => {
  const faqToEdit = message[index];
  navigate(`/faq/edit/${faqToEdit._id}`, { state: { faq: faqToEdit } });
};

const handleViewClick = (index: number) => {
  const faqToView = message[index];
  navigate(`/faq/view/${faqToView._id}`, { state: { faq: faqToView } });
};

  return (
    <div className={styles.container}>
      <div className={styles.content2}>
        <SearchBar searchTerm={searchTerm} onSearch={handleSearchChange}/>
        <div className='flex items-center'>
                    <Link to={'/faq/add'} className={styles.link}>
                        <AddButton label={'ADD FAQ'} />
                    </Link>
        
                    <ExportButton label="Export" exportType={"faq"}/>
                </div>

      </div>
      <Table
        handleSort={handleSort}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        columns={columns}
        data={message.map((faq) => ({
          "_id": faq._id,
          "ID": faq._id,
          'Question': faq.title.eng || '',
          'Answer': faq.answer.eng || '',
          'Created Date': formatDate(faq.createdDate) || '',
        }))}
        onDelete={handleDeleteClick}
        onEdit={handleEditClick}
        onView={handleViewClick}
        loading={loading}
      />
      <div className={styles.content3}>
        <Pagination3
          totalPages={Math.ceil(total / pageSize)}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
      <ArchiveModal
             setIsOpen={setShowModal}

              isOpen={showModal}
              onConfirm={handleConfirmAction}
              onCancel={handleCancelAction}
              header={`Sure you want to Delete this FAQ?`}
              parag={`Are you sure you want to delete this FAQ?`}
              mode={mode}
              buttonText= 'Yes, delete'
            />
    </div>
    
  );
};

export default ContactUs;
